<template>
  <div class="tableTransactions">
    <gl-header icon-name="gr-check" title="Transactions" />
    <gl-transaction
      v-for="tx in txs"
      :key="tx.txid"
      :tx="tx"
      class="tableTransactions__row"
      has-general-header
    >
      <template #header="{ id, time }">
        <slot :id="id" :time="time" name="tx-header" />
      </template>
      <template #input="{ inputs }">
        <slot :inputs="inputs" name="tx-input" />
      </template>
      <template #output="{ minted, outputs, type }">
        <slot :minted="minted" :outputs="outputs" :type="type" name="tx-output" />
      </template>
      <template #confirmation="{ confirmations }">
        <slot :confirmations="confirmations" name="tx-confirmation" />
      </template>
    </gl-transaction>
  </div>
</template>

<script>
import GlHeader from '@gl/GlHeader'
import GlTransaction from '@gl/GlTransaction'

export default {
  name: 'GlTransactions',
  components: { GlTransaction, GlHeader },
  props: {
    txs: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTransactions {
  &__row {
    & + & {
      margin-top: 32px;
    }
  }
}
</style>
